// extracted by mini-css-extract-plugin
export default {"phone":"375px","phone-landscape":"600px","tablet":"768px","tablet-landscape":"1024px","desktop":"1280px","large-desktop":"1440px","extra-large-desktop":"1920px","xsmall":"375px","small":"768px","medium":"1024px","large":"1280px","xlarge":"1440px","xxlarge":"1920px","gutter-width-large":"32px","gutter-width-medium":"24px","gutter-width-small":"16px","gutter-width-xsmall":"8px","homeContent":"Ih7JX3O68SqSwRjCsFC2","headlessWidgetWrapper":"Nm_6cutT02r9MuG76gdT"};
    if(module.hot) {
      // 1741945832689
      var cssReload = require("!../../../node_modules/css-hot-loader/hotModuleReplacement.js")(module.id, {"fileMap":"{fileName}"});
      module.hot.dispose(cssReload);
      module.hot.accept(undefined, cssReload);;
    }
  